import { render, staticRenderFns } from "./list_zfcg.vue?vue&type=template&id=555bf364&scoped=true"
import script from "./list_zfcg.vue?vue&type=script&lang=js"
export * from "./list_zfcg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555bf364",
  null
  
)

export default component.exports